<template>
  <div class="container-fluid p-5" style="margin-top: 50px; margin-bottom: 80px">

    <TableHeader title="Mis Productos" buttonText="CREAR PRODUCTO" routeName="create-product" />

    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <thead class="table-head-dark">
          <tr>
            <th scope="col" class="text-sm" @click="this.sortColumn('name')">
              Nombre
              <i v-if="this.selectedColumn === 'name'" :class="this.sortDirection ? 'icon-angle-down' : 'icon-angle-up'"></i>
            </th>

            <th scope="col" class="text-sm" @click="this.sortColumn('type')">
              Tipo
              <i v-if="this.selectedColumn === 'type'" :class="this.sortDirection ? 'icon-angle-down' : 'icon-angle-up'"></i>
            </th>
            <th scope="col" class="text-sm" @click="this.sortColumn('price')">
              Precio
              <i v-if="this.selectedColumn === 'price'" :class="this.sortDirection ? 'icon-angle-down' : 'icon-angle-up'"></i>
            </th>

            <th scope="col" class="text-align text-sm">Acciones</th>
          </tr>
        </thead>

        <tbody>
          <tr scope="row" v-if="this.loading" style="width: 50vw; height: 2rem">
            <td colspan="4">
              <div class="d-flex justify-content-center">
                <div class="spinner-border" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
            </td>
          </tr>
          <tr scope="row" v-else-if="!this.loading && this.products.length === 0" style="width: 50vw; height: 2rem">
            <td colspan="7" class="text-center">
              <n-p>No se encontraron resultados...</n-p>
            </td>
          </tr>
          <tr v-else-if="!this.loading && this.products.length > 0" v-for="(product, index) in products" :key="index">
            <td scope="row" class="align-middle text-sm" style="text-transform: capitalize">{{ product.name }}</td>

            <td scope="row" class="align-middle text-sm" style="text-transform: capitalize">{{ product.type }}</td>

            <td scope="row" class="align-middle text-sm">{{ product.price?.price || "No especificado" }}</td>

            <td scope="row" class="align-middle">
              <n-tooltip trigger="hover">
                <template #trigger>
                  <router-link :to="{ name: 'edit-product', params: { id: product._id } }" style="text-decoration: none; color: inherit">
                    <i class="icon-edit" style="padding-right: 12px" />
                  </router-link>
                </template>
                Editar
              </n-tooltip>
              <n-tooltip trigger="hover">
                <template #trigger>
                  <span @click="handleConfirm(product)" style="cursor: pointer; padding-bottom: 4px; padding-right: 12px">
                    <i class="icon-trash" />
                  </span>
                </template>
                Eliminar
              </n-tooltip>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useMessage, useDialog } from "naive-ui";
import productStore from "../../store/product";
import authStore from "../../store/auth";
import TableHeader from "../../components/tableHeader.vue";

export default {
  components: {
    TableHeader
},
  data() {
    return {
      message: useMessage(),
      dialog: useDialog(),
      currentProduct: "",
      selectedColumn: "",
      searchBar: "",
    };
  },
  computed: {
    ...mapState(productStore, ["products", "sortDirection", "loading"]),
    ...mapState(authStore, ["isLoggedIn"]),
  },
  methods: {
    ...mapActions(productStore, ["getAllProducts", "removeProduct", "updateProduct", "sortProducts", "searchProducts", "finishLoading"]),
    sortColumn(key) {
      this.sortProducts(key);
      this.selectedColumn = key;
    },
    checkType(type) {
      if (type === "gasoil") {
        return "Gasoil";
      } else {
      }
      if (type === "additives") {
        return "Aditivos";
      }
      if (type === "fertilizer") {
        return "Fertilizante";
      }
      if (type === "fertilizer+phytosanitary") {
        return "Fertilizantes + Fitosanitarios";
      }
      if (type === "seed") {
        return "Semillas";
      }
      if (type === "phytosanitary") {
        return "Fitosanitarios";
      }
    },
    handleConfirm(product) {
      this.dialog.warning({
        title: "Confirmar",
        content: "Esta seguro que desea eliminar el producto?",
        positiveText: "ACEPTAR",
        negativeText: "CANCELAR",
        onPositiveClick: () => {
          this.deleteProduct(product._id);
        },
        onNegativeClick: () => {
          this.message.error("Acción cancelada");
        },
      });
    },
    deleteProduct(id) {
      this.removeProduct(id);
    },
  },

  async created() {
    await this.getAllProducts();
  },
  mounted() {
    if (!this.isLoggedIn) {
      this.message.info("Necesitas iniciar sesión para acceder a esta dirección", { duration: 5000 });
      this.$router.push("/app/login");
    }
  },
};
</script>

<style scoped>
.list-border {
  border-bottom: 1px solid var(--black);
}

.row-collapse-color1 {
  background-color: var(--white);
}

.row-collapse-color2 {
  background-color: var(--white);
}

.table-head-dark {
  background-color: var(--black);
  color: var(--white);
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
}

.table-border {
  border: solid var(--black) 2px;
}
</style>
